import type { AddressDetails } from './types';

function parseStreetAddress(addressComponents: google.maps.places.AddressComponent[]): string {
	const streetNumberComponent = addressComponents.find((component) => component.types.includes('street_number'));
	const routeComponent = addressComponents.find((component) => component.types.includes('route'));

	return [streetNumberComponent?.longText, routeComponent?.longText].filter(Boolean).join(' ');
}

export function parsePlaceDetails({
	addressComponents,
}: {
	addressComponents: google.maps.places.AddressComponent[];
}): AddressDetails {
	const cityComponent =
		addressComponents.find((component) => component.types.includes('locality')) ||
		addressComponents.find((component) => component.types.includes('sublocality'));
	const stateComponent = addressComponents.find((component) => component.types.includes('administrative_area_level_1'));
	const countryComponent = addressComponents.find((component) => component.types.includes('country'));
	const postalCodeComponent = addressComponents.find((component) => component.types.includes('postal_code'));

	return {
		address: parseStreetAddress(addressComponents),
		city: cityComponent?.longText || '',
		stateCode: stateComponent?.shortText || '',
		countryCode: countryComponent?.shortText || '',
		postalCode: postalCodeComponent?.longText || '',
	};
}
